
<header class="header-banner">
	<div class="shell">
		<div class="header__inner">
			<a href="#" class="logo logo--medium">
				<img src="assets/images/logo-medium@2x.png" alt="" width="140" height="59">
			</a>
		</div><!-- /.header__inner -->
	</div><!-- /.shell -->
</header><!-- /.header -->